
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 10.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM8 7a1.25 1.25 0 110 2.5A1.25 1.25 0 018 7zm0-3.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    